import { useEffect } from 'react';
import { session } from '../services/auth/session';

/** Runs the session's token renewal and focus check while the app is mounted. */
export function useSessionLifecycle() {
  useEffect(() => {
    session.start();
    return () => session.stop();
  }, []);
}
